import React from 'react';
import { IQueryResult, IInventoryItem, IInventoryItemsQueryParams } from 'gen/ApiClient';
import { IQueryContext } from 'framework/context/IQueryContext';

export const QueryContext = React.createContext<IQueryContext<IQueryResult<IInventoryItem>, IInventoryItemsQueryParams>>(undefined as any);
